type NativeBridge<TExtended = Record<string, never>> = {
  ready?: boolean;
} & TExtended;

declare const window: Window & { nativeBridge?: NativeBridge };

export const getNativeBridge = <TExtended>() =>
  window.nativeBridge as NativeBridge<TExtended>;

export const isNative = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hasPNSCookie =
    typeof document === 'object' && document.cookie.indexOf('PNS=') > -1;
  const hasNativeBridge = !!getNativeBridge();

  return hasPNSCookie || hasNativeBridge;
};

export interface EventConfig {
  target: string;
  name: string;
  options?: {
    cancelable?: boolean;
    bubbles?: boolean;
    composed?: boolean;
  };
}

export const createNativeEventConfig = (key: string): EventConfig => ({
  target: 'document',
  name: `${key}-${Math.random()}`,
  options: { bubbles: false, cancelable: false, composed: false },
});
